import { Component, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { FormatMsisdnPipe } from 'src/app/shared/pipes/format-msisdn.pipe';
import { UtilsService } from 'src/app/services/utils.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { ANALYTICS, MANAGE_LINE_CONST } from 'src/app/common/core/common.constants';
import { TransactionHistoryService } from 'src/app/services/transaction-histroy.service';


@Component({
  selector: 'app-review-modal',
  templateUrl: './review-modal.component.html',
  styleUrls: ['./review-modal.component.scss'],
  providers: [FormatMsisdnPipe],
})
export class ReviewModalComponent implements OnInit {
  displayMsg: any;
  listOfNonActiveLines: any;
  authoringContentData: any;
  actionTypeName: string;
  modalNameTag: string;
  headerText: string
  removeBtnTxt: any;
  cancelBtnTxt: any;
  strategicPortIn:boolean = false;
  header:any;
  modalBodyContent:any;
  templateObj: any[];
  worksheetname: any;
  response:any;
  transactionLines:any;
  filteredArray: any[];

  constructor(public manageLineService: ManageLineService, public utilsSvc: UtilsService, private pdlService: PDLService, private transactionSvc: TransactionHistoryService) { }

  ngOnInit() {

    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.headerText = this.headerText ?? this.authoringContentData.manageLine.pleaseReviewTxt;
    this.removeBtnTxt = this.removeBtnTxt ?? this.authoringContentData.manageLine.btnRemoveConflictItems;
    this.cancelBtnTxt = this.cancelBtnTxt ?? this.authoringContentData.manageLine.btnCancelTransaction;
    if (this.actionHasTagRequirements()) {
      this.pdlService.ifEnabledGenerateModalViewTag({
        eventAction: ANALYTICS.LOAD,
        modalName: this.modalNameTag,
      });
    }
  }

  close() {
    if (this.actionHasTagRequirements()) {
      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_NAVIGATE,
        action: ANALYTICS.CLICK,
        ctaName: ANALYTICS.CLOSE,
        assetType: ANALYTICS.LINK,
        modalName: this.modalNameTag
      });
    }
    if(this.strategicPortIn){
      this.transactionSvc.fromStrategicPortIn.next(true);
    }
    this.manageLineService.close();
  }

  changeCurrentSelection() {
    if (this.actionHasTagRequirements()) {
      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_NAVIGATE,
        action: ANALYTICS.CLICK,
        ctaName: this.authoringContentData.btnRemoveConflictItems,
        assetType: ANALYTICS.BUTTON,
        modalName: this.modalNameTag
      });
    }
    this.manageLineService.close();
    this.manageLineService.changeCurrentSelection(this.listOfNonActiveLines);
  }

  cancelTransaction() {
    if (this.actionHasTagRequirements()) {
      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_NAVIGATE,
        action: ANALYTICS.CLICK,
        ctaName: this.authoringContentData?.btnCancelTransaction,
        assetType: ANALYTICS.BUTTON,
        modalName: this.modalNameTag
      });
    }
    this.manageLineService.close();
  }

  actionHasTagRequirements() {
    return this.actionTypeName == MANAGE_LINE_CONST.TRANSFER_NUMBER_CTA_TXT;
  }
}
